/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateExternalMediaResponse } from './CreateExternalMediaResponse';
import {
    CreateExternalMediaResponseFromJSON,
    CreateExternalMediaResponseFromJSONTyped,
    CreateExternalMediaResponseToJSON,
    CreateExternalMediaResponseToJSONTyped,
} from './CreateExternalMediaResponse';

/**
 * 
 * @export
 * @interface ResultOfCreateExternalMediaResponse
 */
export interface ResultOfCreateExternalMediaResponse {
    /**
     * 
     * @type {CreateExternalMediaResponse}
     * @memberof ResultOfCreateExternalMediaResponse
     */
    data: CreateExternalMediaResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfCreateExternalMediaResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfCreateExternalMediaResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfCreateExternalMediaResponse interface.
 */
export function instanceOfResultOfCreateExternalMediaResponse(value: object): value is ResultOfCreateExternalMediaResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfCreateExternalMediaResponseFromJSON(json: any): ResultOfCreateExternalMediaResponse {
    return ResultOfCreateExternalMediaResponseFromJSONTyped(json, false);
}

export function ResultOfCreateExternalMediaResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfCreateExternalMediaResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': CreateExternalMediaResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfCreateExternalMediaResponseToJSON(json: any): ResultOfCreateExternalMediaResponse {
    return ResultOfCreateExternalMediaResponseToJSONTyped(json, false);
}

export function ResultOfCreateExternalMediaResponseToJSONTyped(value?: ResultOfCreateExternalMediaResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateExternalMediaResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

